import { create } from 'zustand';
import type { PresenceStatus } from '@/types/domain';

interface PresenceState {
  byUserId: Record<number, { status: PresenceStatus; last_active_at: string | null }>;
  update: (userId: number, status: PresenceStatus, lastActiveAt: string | null) => void;
}

export const usePresenceStore = create<PresenceState>((set) => ({
  byUserId: {},
  update: (userId, status, lastActiveAt) =>
    set((s) => ({
      byUserId: { ...s.byUserId, [userId]: { status, last_active_at: lastActiveAt } },
    })),
}));
